import React, { Component } from 'react';
import {
    Modal,
    Button,
    Input,
    TimePicker,
    Row,
    Col,
    message
} from 'antd';
import moment from 'moment';
import _ from 'lodash';
import { Message } from 'semantic-ui-react';

class UpdateClockModal extends Component {

    constructor(props) {
        super(props);
        this.state = {
            sourceData: { ...this.props.data },
            data: this.props.data,
            errors: []
        }
    }

    _applyDataChange = ({ name, value }) => {
        const { data } = this.state;
        this.setState({
            data: {
                ...data,
                [name]: value
            }
        });
    }

    _createErrorPannel = () => {
        const { errors } = this.state;
        return (_.isEmpty(errors) ? ("") :
            (
                <Message error list={errors} style={{ marginBottom: '3px' }} />
            )
        )
    }

    _submitApplyData = () => {
        const erros = [];
        const { clockIn: sourceClockIn, clockOut: sourceClockOut } = this.state.sourceData;
        const { clockDate, clockIn, clockOut, userAccountId, createdBy, remark } = this.state.data;
        if (_.isEmpty(remark)) {
            erros.push('Remark is required.')
            this.setState({ errors: erros });
            return;
        }
        const sourceClockInStr = sourceClockIn.format('HH:mm:ss');
        const sourceClockOutStr = sourceClockOut?sourceClockOut.format('HH:mm:ss'):null;
        const clockInStr = clockIn.format('HH:mm:ss');
        const clockOutStr = clockOut?clockOut.format('HH:mm:ss'):null;

        const datas = [];
        if(sourceClockInStr !== clockInStr) {
            datas.push({ 
                type: 'ClockIn', 
                status: 'PASS',
                clockDate, 
                userAccountId, 
                createdBy, 
                remark, 
                createdOn: `${clockDate} ${clockIn.format('HH:mm:ss')}`})
        }
        if(sourceClockOutStr !== clockOutStr) {
            datas.push({ 
                type: 'ClockOut', 
                status: 'PASS',
                clockDate, 
                userAccountId, 
                createdBy, 
                remark, 
                createdOn: `${clockDate} ${clockOut.format('HH:mm:ss')}`})
        }
        if(!_.isEmpty(datas)){
            this.props.submitData(datas)
        } else {
            message.info('No change found.');
        }
    }

    _closeModal = () => {
        this.props.closeModal();
    }

    render() {
        const { data } = this.state;
        return (
            <Modal
                size="large"
                visible={true}
                title={`Update ${data.createdBy} ${data.clockDate} Clock`}
                width={450}
                style={{ height: 150 }}
                bodyStyle={{ paddingTop: '5px' }}
                footer={[
                    <Button size="small" type="primary"
                        onClick={() => { this._submitApplyData() }}>
                        Submit
                    </Button>,
                    <Button size="small" type="primary"
                        onClick={() => { this._closeModal() }}>
                        Close
                    </Button>
                ]}
                closable={false}
            >
                <div>
                    <Row gutter={24}>
                        <Col span={5}><b>ClockIn: </b></Col>
                        <Col span={18}><TimePicker size="small"
                            style={{ width: '100%' }}
                            defaultValue={data.clockIn} onChange={(value) => {
                                this._applyDataChange({ name: 'clockIn', value });
                            }} /></Col>
                        <Col span={5}><b>ClockOut: </b></Col>
                        <Col span={18}><TimePicker size="small"
                            style={{ width: '100%' }}
                            defaultValue={data.clockOut} onChange={(value) => {
                                this._applyDataChange({ name: 'clockOut', value });
                            }} /></Col>
                        <Col span={5}><b>Remark: </b></Col>
                        <Col span={18}><Input size="small"
                            style={{ width: '100%', marginTop: '3px' }}
                            defaultValue={data.remark}
                            placeholder='Please input remark' onChange={(e) => {
                                this._applyDataChange({ name: 'remark', value: e.target.value });
                            }} /></Col>
                    </Row>
                    {this._createErrorPannel()}
                </div>
            </Modal>
        );
    }
}

export default UpdateClockModal;
